import { apiGet } from '../api'

export const get_user_permissions = () => {
  return apiGet({
    endpoint: 'userget_user_permissions'
  })
}
